export default import.meta.ROLLDOWN_FILE_URL_Cy7kEfnfQ6HzVqnSUjDhgA